import axiosIns from '@/plugins/axios'

/**
 * モバイルオーダー タブレットキオスクモード用デバイス管理 API
 * (.steering/20260420-mobile-order-tablet-kiosk-mode/)
 */
export default {
  /**
   * 有効端末一覧取得
   */
  index() {
    return axiosIns.get('/waiter/mobile_order_devices')
  },

  /**
   * 新規端末発行 + pairing_token 発行
   * @param {Object} params
   * @param {number} params.hallId
   * @param {number|null} params.tableNumber
   * @param {string} params.name
   */
  create({ hallId, tableNumber, name }) {
    return axiosIns.post('/waiter/mobile_order_devices', {
      mobile_order_device: {
        hall_id: hallId,
        table_number: tableNumber,
        name,
      },
    })
  },

  /**
   * pairing_token 再発行
   * @param {number} id
   */
  regeneratePairing(id) {
    return axiosIns.post(`/waiter/mobile_order_devices/${id}/regenerate_pairing`)
  },

  /**
   * 端末を失効
   * @param {number} id
   */
  destroy(id) {
    return axiosIns.delete(`/waiter/mobile_order_devices/${id}`)
  },
}
